import { useParams } from 'react-router-dom';
import { Row, Col, Card, Spin } from 'antd';
import { useQuery } from '@tanstack/react-query';
import LineChart from 'src/components/chart/LineChart';
import { useContext } from 'react';
import { getSignals } from 'src/services/spec.service';
import { formatDate } from 'src/utils/util';
import { DateContext } from 'src/components/layout/Main';
import pnlChart from 'src/components/chart/configs/pnlChart';

function Spec() {
  const { specName } = useParams();
  const { timeRange } = useContext(DateContext);

  const { data: signalsData, isLoading: signalsLoading } = useQuery({
    queryKey: [
      'signals',
      specName,
      {
        start_date: formatDate(timeRange[0]),
        end_date: formatDate(timeRange[1]),
      },
    ],
    queryFn: getSignals,
  });

  return (
    <div className='layout-content'>
      <Row gutter={[24, 0]}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24} className='mb-24'>
          <Spin spinning={signalsLoading} tip='Loading...'>
            <Card bordered={false} className='criclebox h-full'>
              <LineChart
                title='Signals'
                series={signalsData?.result}
                options={pnlChart.options}
              />
            </Card>
          </Spin>
        </Col>
      </Row>
    </div>
  );
}

export default Spec;
